import React, { useContext } from 'react'
import './Header.css'
import { IoMenu } from "react-icons/io5";
import { MainContext } from '../ContextStore/MainContext';
import { getDeadlineStatus } from '../../utils/deadlineChecker';

import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';

export default function Header({ onScrollTo }) {
  const { windowWidth,setHackathonType } = useContext(MainContext)
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  }; 

  return (
    <div className='header_component'>
      <img src='ksr_main_logo.png' alt='logo' className='header_logo'></img>
      {windowWidth >= 1000 ?
        <div className='social_media_section'>
          <p className='headerItem' onClick={() =>{setHackathonType("current");onScrollTo("about");}}>About</p>
          <p className='headerItem' onClick={() =>{setHackathonType("current");onScrollTo("dataset");}}>Dataset</p>
          <p className='headerItem' onClick={() =>{onScrollTo("evaluation");setHackathonType("current")}}>Evaluation Criteria</p>
          <p className='headerItem' onClick={() => {onScrollTo("prizes");setHackathonType("current")}}>Prizes</p>
          <p className='headerItem' onClick={() => {onScrollTo("submission");setHackathonType("current")}}>Submission Guidelines</p>
          <p className='headerItem' onClick={() => {onScrollTo("faq");setHackathonType("current")}}>FAQs</p>

          <span className='register_button_header'
            onClick={() => {
              const status = getDeadlineStatus();
              if (!status.isOpen) {
                alert(status.message);
                return;
              }
              window.open('https://www.datavizon.com/course/DataHackathon-4EventManagementChallange-96807', "_blank")
            }}
          >Register Now</span>
        </div> :

        <div>
          <Button onClick={toggleDrawer(true)}><IoMenu className='menubar_icon' /></Button>
          <Drawer open={open} onClose={toggleDrawer(false)} anchor='right'>
            <div className='menubar_icons_section' onClick={()=>setHackathonType("current")}>
              <p className='headerItem' onClick={() => onScrollTo("about")}>About</p>
              <p className='headerItem' onClick={() => onScrollTo("dataset")}>Dataset</p>
              <p className='headerItem' onClick={() => onScrollTo("evaluation")}>Evaluation Criteria</p>
              <p className='headerItem' onClick={() => onScrollTo("prizes")}>Prizes</p>
              <p className='headerItem' onClick={() => onScrollTo("submission")}>Submission Guidelines</p>
              <p className='headerItem' onClick={() => onScrollTo("faq")}>FAQs</p>
              <span className='register_button_header'
                onClick={() => {
                  const status = getDeadlineStatus();
                  if (!status.isOpen) {
                    alert(status.message);
                    return;
                  }
                  window.open('https://www.datavizon.com/course/DataHackathon-4EventManagementChallange-96807', "_blank")
                }}
              >Register Now</span>
            </div>
          </Drawer>
        </div>
      }
    </div>
  )
}
